<template>
  <validation-observer v-slot="{ valid }">
    <validation-helper :interceptor="valid" @isValid="$emit('stepReleased', $event)" />
    <v-row class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field id="titulo" v-model="titulo" class="my-0" label="Título" outlined :error-messages="errors" />
        </validation-provider>
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col cols="12">
        <v-textarea
          id="obras"
          v-model="obras"
          class="mt-0 pt-0"
          label="Obras"
          placeholder="Insira os códigos das obras, um por linha. Ex.:

CI1944457111 
CI1944457348"
          rows="5"
          no-resize
          clearable
          clear-icon="mdi-close-circle"
          :disabled="disableObras"
        />
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col cols="12">
        <v-textarea
          id="centros-custo"
          v-model="centrosCusto"
          class="mt-0 pt-0"
          label="Centros Custo"
          placeholder="Insira os códigos dos centros de custo, um por linha. Ex.:

1010200118 
1010200106"
          rows="5"
          no-resize
          clearable
          clear-icon="mdi-close-circle"
        />
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col cols="12">
        <v-textarea
          id="tipos"
          v-model="tipos"
          class="mt-0 pt-0"
          label="Tipos"
          placeholder="Insira os códigos dos tipos, um por linha. Ex.:

13 
14"
          rows="5"
          no-resize
          clearable
          clear-icon="mdi-close-circle"
          :disabled="disableTipos"
        />
      </v-col>
    </v-row>

    <v-row id="data-lancamento-perdas-aic" class="mt-n3 mx-auto">
      <v-col class="pt-0" xl="5" lg="5" md="5" sm="5" cols="12">
        <date-picker
          v-model="dataLancamentoInicio"
          label="Data Lançamento"
          type="date"
          :rules="`date_precisa_ser_menor_ou_igual_a:${dataLancamentoFim}`"
        />
      </v-col>
      <v-col xl="2" lg="2" md="2" sm="2" cols="12" class="text-center" style="min-width: 60px !important; padding-top: 32px">
        <span style="color: rgba(0, 0, 0, 0.54); font-size: 15px">até</span>
      </v-col>
      <v-col class="pt-0" xl="5" lg="5" md="5" sm="5" cols="12">
        <date-picker
          v-model="dataLancamentoFim"
          label="Data Lançamento"
          type="date"
          :rules="`date_precisa_ser_maior_ou_igual_a:${dataLancamentoInicio}`"
        />
      </v-col>
    </v-row>
  </validation-observer>
</template>

<script>
  export default {
    components: {
      ValidationHelper: () => import('@/components/general/ValidationHelper.vue'),
      DatePicker: () => import('@/components/general/DatePicker.vue')
    },

    emits: ['stepReleased'],

    data: () => ({
      disableObras: false,
      disableTipos: false
    }),

    computed: {
      titulo: {
        get() {
          return this.$store.state.perdasAic.titulo;
        },
        set(value) {
          this.$store.dispatch('setPerdasAic', { titulo: value });
        }
      },
      obras: {
        get() {
          return this.$store.state.perdasAic.obras;
        },
        set(value) {
          this.$store.dispatch('setPerdasAic', { obras: value });
        }
      },
      centrosCusto: {
        get() {
          return this.$store.state.perdasAic.centrosCusto;
        },
        set(value) {
          this.$store.dispatch('setPerdasAic', { centrosCusto: value });
        }
      },
      tipos: {
        get() {
          return this.$store.state.perdasAic.tipos;
        },
        set(value) {
          this.$store.dispatch('setPerdasAic', { tipos: value });
        }
      },
      dataLancamentoInicio: {
        get() {
          return this.$store.state.perdasAic.dataLancamentoInicio;
        },
        set(value) {
          this.$store.dispatch('setPerdasAic', { dataLancamentoInicio: value });
        }
      },
      dataLancamentoFim: {
        get() {
          return this.$store.state.perdasAic.dataLancamentoFim;
        },
        set(value) {
          this.$store.dispatch('setPerdasAic', { dataLancamentoFim: value });
        }
      }
    },

    watch: {
      obras(val) {
        if (val === null) this.disableTipos = false;

        if (val !== null && val.length > 0) {
          this.disableTipos = true;
          this.tipos = '';
        }
      },
      tipos(val) {
        if (val === null) this.disableObras = false;

        if (val !== null && val.length > 0) {
          this.disableObras = true;
          this.obras = '';
        }
      }
    }
  };
</script>